<template>

    <div v-if="adCar" class="circle" :style="{'background-color': adCar.color}"></div>

</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'ThemeCircle',
    computed: {
        ...mapGetters({adCar: 'main/adCar'})
    }
}
</script>

<style scoped>
.circle{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    clip-path: circle(600px at right 800px);
}
</style>